<template>
    <div class="kefu-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ $t('user.onlineService') }}</div>
        </header>

        <main class="page-content">
            <section class="hero-card">
                <div class="hero-copy">
                    <span class="hero-tag">SUPPORT</span>
                    <h1>{{ getLabel('pageKefu.heroTitle', '专属客服通道') }}</h1>
                    <p>{{ getLabel('pageKefu.heroText', '如遇到账、提现、账户安全或产品问题，可通过下方官方客服入口快速联系人工处理。') }}</p>
                </div>
                <div class="hero-icon">
                    <van-icon name="service-o" />
                </div>
            </section>

            <section class="contact-card">
                <div class="card-title">{{ getLabel('pageKefu.entryTitle', '客服入口') }}</div>
                <div class="link-box">{{ displayLink }}</div>

                <div class="action-row">
                    <button type="button" class="primary-btn" @click="openKefu">
                        {{ getLabel('pageKefu.contactNow', '立即联系') }}
                    </button>
                    <button type="button" class="ghost-btn" @click="copyLink">
                        {{ getLabel('pageKefu.copyLink', '复制链接') }}
                    </button>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Icon).use(Toast);

export default {
    name: "kefu",
    data() {
        return {
            kefuLink: "",
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    computed: {
        displayLink() {
            return this.kefuLink;
        },
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        this.start();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        async start() {
            const storeLink = this.$store && this.$store.state && this.$store.state.config
                ? this.$store.state.config.kefu_link
                : "";
            if (storeLink) {
                this.kefuLink = storeLink;
                return;
            }
            try {
                const res = await Fetch("/index/webconfig");
                const webconfigLink = res && res.data ? res.data.kefu_link : "";
                this.kefuLink = webconfigLink || "";
            } catch (error) {
                this.kefuLink = "";
            }
        },
        openKefu() {
            window.location.href = this.displayLink;
        },
        copyLink() {
            const link = this.displayLink;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(link).then(() => {
                    this.$toast(this.getLabel("pageKefu.copySuccess", "客服链接已复制"));
                }).catch(() => {
                    this.fallbackCopy(link);
                });
                return;
            }
            this.fallbackCopy(link);
        },
        fallbackCopy(link) {
            const input = document.createElement("input");
            input.value = link;
            document.body.appendChild(input);
            input.select();
            try {
                document.execCommand("copy");
                this.$toast(this.getLabel("pageKefu.copySuccess", "客服链接已复制"));
            } catch (error) {
                this.$toast(this.getLabel("pageKefu.copyFailed", "复制失败，请手动复制"));
            }
            document.body.removeChild(input);
        },
    },
};
</script>

<style lang="less" scoped>
.kefu-page {
    min-height: 100vh;
    background:
        radial-gradient(circle at top right, rgba(33, 86, 255, 0.2), transparent 28%),
        linear-gradient(180deg, #020612 0%, #000000 52%, #000000 100%);
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.88);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.hero-card,
.contact-card {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 18px;
    background: rgba(6, 18, 52, 0.62);
    box-shadow: inset 0 0 0 1px rgba(45, 91, 255, 0.08);
    backdrop-filter: blur(12px);
}

.hero-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 22px 18px;
    margin-bottom: 18px;
}

.hero-copy {
    flex: 1;
    min-width: 0;
}

.hero-tag {
    display: inline-block;
    margin-bottom: 10px;
    color: #6c7cff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 2px;
}

.hero-copy h1 {
    margin: 0 0 10px;
    color: #fff;
    font-size: 28px;
    font-weight: 800;
    line-height: 1.15;
}

.hero-copy p {
    margin: 0;
    color: rgba(255, 255, 255, 0.58);
    font-size: 12px;
    line-height: 1.8;
}

.hero-icon {
    width: 72px;
    height: 72px;
    border-radius: 20px;
    background: rgba(45, 91, 255, 0.12);
    box-shadow: 0 0 24px rgba(45, 91, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.hero-icon .van-icon {
    font-size: 34px;
    color: #2d5bff;
}

.contact-card {
    padding: 18px 16px;
}

.contact-card {
    margin-bottom: 18px;
}

.card-title {
    margin-bottom: 14px;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}

.link-box {
    min-height: 56px;
    padding: 14px 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.02);
    color: rgba(255, 255, 255, 0.82);
    font-size: 14px;
    line-height: 1.7;
    word-break: break-all;
}

.action-row {
    display: flex;
    gap: 10px;
    margin-top: 16px;
}

.primary-btn,
.ghost-btn {
    flex: 1;
    height: 46px;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 700;
}

.primary-btn {
    border: 0;
    background: linear-gradient(135deg, #2d5bff 0%, #104af0 100%);
    box-shadow: 0 4px 15px rgba(45, 91, 255, 0.3);
    color: #fff;
}

.ghost-btn {
    border: 1px solid rgba(45, 91, 255, 0.35);
    background: rgba(45, 91, 255, 0.08);
    color: #7fa0ff;
}

</style>
